import React, { Fragment, Component, createRef } from 'react';

import { withT } from '../../context/t';
import Sidemenu from './Sidemenu';
import Text from '../Text';

import { LayoutProvider } from '../../context/layout';

import CustomHeader from '../../custom-components/Header.jsx';
import CustomFooter from '../../custom-components/Footer.jsx';

class Layout extends Component {
  constructor(props) {
    super(props);

    this.mainRef = createRef();
    this.modalRef = createRef();
    this.advertRef = createRef();

    this.state = {
      mainRef: null,
      modalRef: null,
      advertRef: null,
    };
  }

  updateLayoutContext() {
    const { mainRef, modalRef, advertRef } = this.getRefs();

    if (
      mainRef !== this.mainRef.current ||
      modalRef !== this.modalRef.current ||
      advertRef !== this.advertRef.current
    ) {
      this.setState({
        mainRef: this.mainRef.current,
        modalRef: this.modalRef.current,
        advertRef: this.advertRef.current,
      });
    }
  }

  getRefs() {
    return {
      mainRef: this.state.mainRef,
      modalRef: this.state.modalRef,
      advertRef: this.state.advertRef,
    };
  }

  componentDidUpdate() {
    this.updateLayoutContext();
  }

  componentDidMount() {
    this.updateLayoutContext();
  }

  render() {
    return (
      <Fragment>
        <CustomHeader />
        <header className="tool-header mb-5">
          <div className="tool-header__wrapper">
            <div className="tool-header__title">
              <Text i18nKey="displayName" inline />
            </div>
            <div className="tool-header__subtitle" />
          </div>
        </header>
        <div className="constrain-l">
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <Sidemenu sidebarDisabled={this.props.sidebarDisabled} />
            </div>
            <div className="col-xs-12 col-sm-8" ref={this.mainRef}>
              <div className="px-4">
                <LayoutProvider value={this.getRefs()}>
                  {this.props.children}
                </LayoutProvider>
              </div>
            </div>
            <div className="col-xs-12 col-sm-2">
              <div className="infobox-container" ref={this.modalRef} />
              <div className="upsell-container" ref={this.advertRef} />
            </div>
          </div>
        </div>
        <CustomFooter />
      </Fragment>
    );
  }
}

export default withT('tool')(Layout);
